import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  counter: {
    textAlign: 'right',
    fontSize: '12px',
    color: palette.shades[700]
  }
});
export default useStyles;